/** Google Analytics 4 (gtag.js) — meetcode van Vakkundig Verhuizingen & Transport. */
export const GA_MEASUREMENT_ID = "G-SXKB2P844D";

type GtagWindow = Window & {
  dataLayer?: unknown[];
  gtag?: (...args: unknown[]) => void;
};

function gtag(...args: unknown[]) {
  const w = window as GtagWindow;
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push(args);
}

/** Paginaweergave melden bij navigatie binnen de site (gtag doet alleen de eerste load zelf). */
export function trackPageView(path: string) {
  if (typeof window === "undefined") return;
  gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

/** Losse gebeurtenis, bijvoorbeeld een offerteaanvraag of WhatsApp-klik. */
export function trackEvent(name: string, params: Record<string, unknown> = {}) {
  if (typeof window === "undefined") return;
  gtag("event", name, params);
}
